// extracted by mini-css-extract-plugin
export default {"text-container":"text_text-container__dA34r"};